module.exports = __webpack_public_path__ + "media/site_templates/www.furnituremovingservices.com.au/images/testimonials-7a470c3d5d8dff44dad2643bfe83d356.jpg";